'use strict';

import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import theme from '../../theme/theme';
import { API_URL, API_PROD_URL } from '../../actions/application';
import { TrustpilotCarousel } from './Trust';
import logo from './assets/kasvurahoitus-logo-trim.png';
import footerLogos from './assets/kasvurahoitus-yrittajat.png';
import './v2.css';

/**
 * Shared page frame for the v2 application forms: promo bar, header with the phone
 * button, the flow itself, guidance text, Trustpilot carousel and the footer.
 */

export const TERMS_URL = 'https://www.kasvurahoitus.fi/front-kasvurahoitus-kaeyttoeehdot/';
export const PHONE = { href: 'tel:+358968298003', label: '09 6829 8003', intl: '+358 9 6829 8003' };
const isMockApi = API_URL !== API_PROD_URL;

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export default function PageFrame({ promo, contactEmail, afterForm, children }) {
  return (
    <ThemeProvider theme={theme}>
      <div className="krv2">
        {isMockApi && (
          <div className="kr-devbar">
            KEHITYSTILA · API: {API_URL} · tunnistautuminen {process.env.REACT_APP_AUTH_BYPASS === 'true' ? 'ohitetaan' : 'käytössä'} · mitään ei lähetetä oikeaan järjestelmään
          </div>
        )}

        <div className="kr-promo">{promo}</div>

        <header className="kr-header">
          <div className="kr-container kr-header-inner">
            <a href="https://www.kasvurahoitus.fi/" className="kr-brand" aria-label="Kasvurahoitus etusivu">
              <img src={logo} alt="Kasvurahoitus" className="kr-brand-logo" />
            </a>
            <a href={PHONE.href} className="kr-phone-pill" aria-label={`Soita asiakaspalveluun ${PHONE.label}`}>
              <PhoneIcon />
              <span className="kr-ph-num">{PHONE.label}</span>
            </a>
          </div>
        </header>

        {children}

        {afterForm && <section className="kr-after-form">{afterForm}</section>}

        <section className="kr-reviews" aria-label="Asiakkaidemme arviot">
          <h3>Asiakkaidemme kokemuksia</h3>
          <TrustpilotCarousel />
        </section>

        <footer className="kr-footer">
          <div className="kr-container">
            <div className="kr-footer-logos"><img src={footerLogos} alt="Kasvurahoitus – Suomen Yrittäjien kumppani" /></div>
            <div className="kr-footer-contact">
              <div><a href={PHONE.href}>{PHONE.intl}</a> <span className="kr-muted">(ark. klo 9–16)</span></div>
              <div><a href={`mailto:${contactEmail}`}>{contactEmail}</a></div>
            </div>
          </div>
        </footer>
      </div>
    </ThemeProvider>
  );
}
